module.exports = __webpack_public_path__ + "img/adi_logo.593789b5.png";